import EditorRow from 'builder/components/EditorRow'
import { FirstName } from 'builder/components/DocumentEditor/Japanese/PersonalDetails/FirstName'
import { LastName } from 'builder/components/DocumentEditor/Japanese/PersonalDetails/LastName'
import EditorField from 'builder/components/EditorField'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { SectionBodyFoldableContainer } from 'builder/components/Section'
import { Container } from './styles'
import { SubmissionDate } from './SubmissionDate'

const ShokumuPersonalDetailsSection = (): JSX.Element => {
  const resume = useTypedSelector(store => store.resumeEditor.resume)

  return (
    <Container>
      <SectionBodyFoldableContainer isOpened={true}>
        <EditorRow>
          <SubmissionDate />
          <EditorField quarterWidth={true}>
            <LastName lastName={resume?.lastName} />
          </EditorField>
          <EditorField quarterWidth={true}>
            <FirstName firstName={resume?.firstName} />
          </EditorField>
        </EditorRow>
      </SectionBodyFoldableContainer>
    </Container>
  )
}
export default ShokumuPersonalDetailsSection
